module.exports = __webpack_public_path__ + "static/media/303ColumnLabel--4.52733b8e.svg";